import React from 'react';
import { X, PencilRuler, FileSpreadsheet, Printer, ImagePlus, Search, HelpCircle } from 'lucide-react';
import { tagThemeClass } from './tagTheme';

const TIPS = [
  { icon: PencilRuler, title: 'Manual tag', text: 'Create a single tag with weights, purity, stones and notes. Net weight is calculated for you.' },
  { icon: FileSpreadsheet, title: 'Import from Excel', text: 'Download the template, fill many tags at once and upload — each Jewellery No becomes a card.' },
  { icon: Printer, title: 'Print', text: 'Use "Tag" on a card for one tag, or Batch print to make a PDF of many tags (full tag, QR only or QR + image).' },
  { icon: ImagePlus, title: 'Replace image', text: 'Swap a card photo. Large photos are compressed automatically to the allowed size.' },
  { icon: Search, title: 'Find pieces', text: 'Search by jewellery number or title and filter by date. 30 cards are shown per page.' },
];

export function TagHelpDialog({ open, onClose }) {
  if (!open) return null;
  return (
    <div className={`tag-scope ${tagThemeClass()} fixed inset-0 z-[200] flex items-center justify-center p-4`} data-testid="tagws-help-dialog">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-[2px]" onClick={onClose} />
      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-border bg-card p-5 shadow-xl">
        <div className="mb-4 flex items-start justify-between">
          <h3 className="flex items-center gap-2 text-lg font-semibold tracking-tight text-foreground"><HelpCircle size={18} className="text-[hsl(var(--ring))]" /> Quick guide</h3>
          <button onClick={onClose} aria-label="Close" data-testid="tagws-help-close-button" className="text-muted-foreground hover:text-foreground"><X size={18} /></button>
        </div>
        <ul className="space-y-3">
          {TIPS.map(({ icon: I, title, text }) => (
            <li key={title} className="flex gap-3">
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-[hsl(var(--accent))] text-foreground"><I size={15} /></span>
              <div><div className="text-sm font-semibold text-foreground">{title}</div><div className="text-xs text-muted-foreground">{text}</div></div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
